/* Hvattum Studios — homepage product card.

   Adding to the cart, the loading state, duplicate-submission prevention and
   the cart interface itself are all handled by Dawn's own <product-form> and
   cart components. This element only listens on Dawn's pubsub channel so a
   failed add is reported inside the card it came from, instead of being lost
   behind the hover state. */

if (!customElements.get('hvattum-product-card')) {
  customElements.define(
    'hvattum-product-card',
    class HvattumProductCard extends HTMLElement {
      connectedCallback() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

        this.errorTarget = this.querySelector('[data-hvattum-card-error]');
        if (!this.errorTarget) return;

        this.unsubscribers = [
          subscribe(PUB_SUB_EVENTS.cartError, (event) => this.onCartError(event)),
          subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => this.onCartUpdate(event)),
        ];
      }

      disconnectedCallback() {
        this.unsubscribers?.forEach((unsubscribe) => unsubscribe());
      }

      // Only respond to a variant this card actually offers, so one card's
      // failure is never reported on another.
      ownsVariant(variantId) {
        if (!variantId) return false;
        return !!this.querySelector(`input[name="id"][value="${CSS.escape(String(variantId))}"]`);
      }

      onCartError(event) {
        if (!this.ownsVariant(event?.productVariantId)) return;

        const message = event?.message || event?.errors;
        // Reveal the live region before writing to it, so assistive technology
        // announces the change rather than a region that was hidden at the time.
        this.errorTarget.hidden = false;
        this.errorTarget.textContent =
          typeof message === 'string' && message.length > 0
            ? message
            : 'This size could not be added to the cart. Please try again.';
      }

      onCartUpdate(event) {
        if (!this.ownsVariant(event?.productVariantId)) return;

        this.errorTarget.textContent = '';
        this.errorTarget.hidden = true;
      }
    }
  );
}
